<template>
    <div class="container--terms">
        <div class="terms-wrapper">

            <div class="hero-inner hero-section text-center position-relative p-3 p-md-5 bg-gradient-green">
                <h1 class="hero-inner--title mx-auto position-relative">
                    Términos y Condiciones
                </h1>
            </div>

            <div class="container--terms__subtitle bg__gray-light">
                <div class="container">
                    <p>El acceso y uso de la aplicación Ginny se encuentran sujetos a los siguientes “Términos y condiciones”(Términos de uso) y Política de Privacidad establecen los términos en que Ginny App y ginnyapp.com utilizan para el uso de su aplicación y Website y protege la información que es proporcionada por sus usuarios al momento de utilizar sus servicios.</p>
                </div>
            </div>

            <div class="bullet--terms">
                <div class="container">
                    <h3 class="mb-4 mt-4">Al aceptar los términos y condiciones el usuario reconoce, acepta y declara lo siguiente: </h3>
                    <ul class="bullet--list">
                        <li><span class="bullet--list__image">1</span>Que Ginny App es propiedad exclusiva de MCTEKK SRL, sociedad organizada y existente de conformidad con las leyes de la República Dominicana, inscrita en el Registro Nacional de Contribuyentes bajo el número 1-30-33976-7 (en lo adelante MCTEKK).</li>
                        <li><span class="bullet--list__image">2</span>Que Ginny App es una aplicación que permite a sus usuarios administrar sus tarjetas de crédito y débito sin guardar la información de las mismas.</li>
                        <li><span class="bullet--list__image">3</span>Que el registro y uso del App es totalmente gratuito, salvo en sus versiones Premium y Empresarial.</li>
                        <li><span class="bullet--list__image">4</span>Que MCTEKK SRL no es una entidad financiera ni crediticia.</li>
                        <li><span class="bullet--list__image">5</span>Que MCTEKK SRL utiliza un protocolo SSL que maneja los datos de forma íntegra y segura (encriptados), por lo tanto Ginny App no maneja transacciones.</li>
                    </ul>
                </div>
            </div>

            <div class="policy">
                <div class="container">
                    <h3>Políticas de Privacidad</h3>
                    <p>Ginny App está comprometida con la seguridad de los datos de sus usuarios. Cuando le solicitamos proporcionar los datos de información personal con los cuales usted puede ser identificado, lo hacemos asegurando que solo se emplearán de acuerdo con los términos de este documento.<br /><br />

                    Esta Política de Privacidad puede cambiar o ser actualizada con el tiempo, por lo que le recomendamos y enfatizamos revisar continuamente esta página para asegurarse que está de acuerdo con dichos cambios. Ginny App estará informando en caso de que la política sea actualizada.</p>

                    <strong>Información que es recopilada</strong><br />
                    <p>Nuestro sitio web podrá recopilar información personal por ejemplo: Nombre,  información de contacto como  su dirección e-mail e información demográfica. Así mismo cuando sea necesario podrá ser requerida información específica para procesar algún pedido o realizar una entrega o facturación.<br /><br />

                    <strong>Uso de la información recopilada</strong><br />
                    Nuestro sitio web emplea la información con el fin de proporcionar el mejor servicio posible, particularmente para mantener un registro de usuarios, y mejorar nuestros productos y servicios.  Es posible que sean enviados correos electrónicos periódicamente a través de nuestro sitio con información especial, nuevas adiciones a la aplicación y otra información publicitaria que consideremos relevante para usted o que pueda brindarle algún beneficio, estos correos electrónicos serán enviados a la dirección que usted proporcione y podrán ser cancelados en cualquier momento.</p><br />

                    <p>Ginny App está altamente comprometida para cumplir con el compromiso de mantener su información segura. Usamos los sistemas más avanzados y los actualizamos constantemente para asegurarnos que no exista ningún acceso no autorizado.<p/><br />

                    <strong>Cookies</strong><br />
                    <p>Una cookie se refiere a un fichero que es enviado con la finalidad de solicitar permiso para almacenarse en su ordenador, al aceptar dicho fichero se crea y la cookie sirve entonces para tener información respecto al tráfico web, y también facilita las futuras visitas a una web recurrente. Otra función que tienen las cookies es que con ellas las web pueden reconocerte individualmente y por tanto brindarte el mejor servicio personalizado de su web.<p/><br />

                    <p>Nuestro sitio web emplea las cookies para poder identificar las páginas que son visitadas y su frecuencia. Esta información es empleada únicamente para análisis estadístico y después la información se elimina de forma permanente. Usted puede eliminar las cookies en cualquier momento desde su ordenador. Sin embargo las cookies ayudan a proporcionar un mejor servicio de los sitios web, estas no dan acceso a información de su ordenador ni de usted, a menos de que usted así lo quiera y la proporcione directamente, visitas a una web. Usted puede aceptar o negar el uso de cookies, sin embargo la mayoría de navegadores aceptan cookies automáticamente pues sirve para tener un mejor servicio. También usted puede cambiar la configuración de su ordenador para declinar las cookies. Si se declinan es posible que no pueda utilizar algunos de nuestros servicios.</p><br />

                    <strong>Enlaces a Terceros</strong><br />
                    <p>Este sitio web pudiera contener enlaces a otros sitios que pudieran ser de su interés. Una vez que usted haga clic en estos enlaces y abandone nuestra página, ya no tenemos control sobre al sitio al que es redirigido y por lo tanto no somos responsables de los términos o privacidad ni de la protección de sus datos en esos otros sitios terceros. Dichos sitios están sujetos a sus propias políticas de privacidad por lo cual es recomendable que los consulte para confirmar que usted está de acuerdo con estas.</p>

                    <strong>Control de su información personal</strong><br />
                    <p>En cualquier momento usted puede restringir la recopilación o el uso de la información personal que es proporcionada a nuestro sitio web. Cada vez que se le solicite rellenar un formulario, como el de alta de usuario, puede marcar o desmarcar la opción de recibir información por correo electrónico. En caso de que haya marcado la opción de recibir nuestro boletín o publicidad usted puede cancelarla en cualquier momento.</p><br />

                    <p>Para la eliminacion de cuentas de usuario por favor enviar un correo a soporte@ginnyapp.com y se procesara la solicitud en 48h</p><br />

                    <p>Esta empresa no venderá, cederá ni distribuirá la información personal que es recopilada sin su consentimiento, salvo que sea requerido por un juez con un orden judicial.</p><br />
                    <p>Ginny App se reserva el derecho de cambiar los términos de la presente Política de Privacidad en cualquier momento.</p><br />
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
  name: 'Terms'
}
</script>

<style lang="scss" scoped>
.hero-inner {
    display: flex;
    min-height:408px;

    .hero-inner--title {
        display: flex;
        justify-content: center;
        align-items: center;
        font-family: $primary-font;
        font-size: 56px;
        font-weight: 700;
        color: #fff!important;
    }
}

.container--terms {
    .container--terms__subtitle {
        p {
            font-size:$medium-font-size;
        }
    }

    .container {
        max-width: 1300px;
        padding: 30px 40px;
    }

    .bullet--terms {
        h3 {
            font-size:$medium-font-size;
        }

        .bullet--list {
            list-style: none;
            padding-left: 0;

            li {
                line-height:30px;
                margin-bottom:10px;
                display: flex;
                align-items: center;
            }

            .bullet--list__image {
                border-radius: 50%;
                padding: 3px;
                max-height: 40px;
                max-width: 35px;
                width:100%;
                height:100%;
                background-color: $orange-color;
                text-align:center;
                color: white;
                font-size:$small-font-size;
                font-weight:600;
                margin-right:15px;
            }
        }
    }

    .policy {
        h3 {
            background:$primary-color;
            font-family:$primary-font;
            color:$white-color;
            padding:24px 16px;
            margin-bottom:30px;
        }

        strong {
            color:$orange-color;
            font-size:$small-font-size;
        }
    }
}
.bg__gray-light{
    background:$gray-light-background;
}

// Medium devices (tablet, 768px)
@media screen and (max-width: 768px) {
.container--terms {
    .container--terms__subtitle {
        p {
            font-size:$small-font-size;
        }
    }

    .bullet--terms {

        .bullet--list {

            li {
                align-items: flex-start;
            }
        }
    }
}

}
</style>
